import React from 'react';
import { string } from 'prop-types';

/**
 * necessary because the actual content images are not in the served markup
 * due to lazy loading / performance.
 */
function NoscriptImageFallback(props) {
  const { url, alt } = props;

  return (
    <noscript>
      <img src={url} alt={alt} />
    </noscript>
  );
}

NoscriptImageFallback.propTypes = {
  url: string.isRequired,
  alt: string.isRequired
};

export default NoscriptImageFallback;
